import { Select } from 'antd'

const AlumniDataRibbon = ({
  isImportVisible,
  filterValue,
  setFilterValue,
}) => {
  let statusItems = [
    {  
      value: 0, 
      label: '全部'
    },
    {
      value: 1,
      label: '未认领'
    },
    {
      value: 2,
      label: '已认领'
    }
  ]

  const clickStatusFilter = (value) => {
    setFilterValue({ ...filterValue, status: value })
  }

  return (
    <div className='ribbon-page'>
      <div className='ribbon-container'>
        <div className='ribbon-button-primary' onClick={() => { isImportVisible() }}>导入数据</div>
        <Select
          placeholder="认领状态"
          options={statusItems}
          style={{height: '32px', width: '200px'}}
          onChange={(value) => clickStatusFilter(value)}
        />
      </div>
    </div>
  )
}

export default AlumniDataRibbon
